import { Typography } from "@mui/material";
import classNames from "classnames";

import styles from "./MessagePathLabel.module.css";

export interface MessagePathLabelProps {
  className?: classNames.Argument;
  dataType: string;
  label: string;
  match?: {
    position: [number, number];
  };
}

/**
 * Renders a label for a message path.
 */
export function MessagePathLabel(props: MessagePathLabelProps) {
  const { className, dataType, label, match } = props;

  /* Add the highlight logic here so this component needs access to 
    1. the matched text. this means every components needs to compute the match indexes
    2. it takes the match object which contains the match ranges to highlight. This is
    precomputed and passed as a prop. It's existence determines whether we render the
    highlight or not.
  */
  return (
    <div className={classNames(className, styles.labelContainer)}>
      <p
        className={classNames(
          "ph-no-capture",
          styles.hideOverflow,
          styles.label,
        )}
      >
        <Label label={label} match={match} />
        <Typography
          component={"span"}
          className={classNames(styles.dataTypeLabel, styles.hideOverflow)}
          color="text.secondary"
        >
          {dataType}
        </Typography>
      </p>
    </div>
  );
}

interface LabelProps {
  label: string;
  match?: {
    position: [number, number];
  };
}

export function Label({ label, match }: LabelProps) {
  if (match) {
    return (
      <>
        {label.slice(0, match.position[0])}
        <span className={styles.highlight}>
          {label.slice(match.position[0], match.position[1])}
        </span>
        {label.slice(match.position[1])}
      </>
    );
  }

  return label;
}
